import { Modal, ModalId, O, option, RadioField, Validatable } from "../../../../features/ui"
import { useEffect, useMemo, useState } from "react"
import { BulkAction } from "./types"
import { firstItem, toList } from "../../../../utils/listUtils"

type Props = {
    ids: string[]
    bulkActions: BulkAction[]
}

export const BulkEditModal = (props: Props) => {
    const { ids, bulkActions } = props

    const [selectedAction, setSelectedAction] = useState<BulkAction>(firstItem(bulkActions)!)
    const [suitableIds, setSuitableIds] = useState<string[]>([])
    const [validation, setValidation] = useState<O<string>>()

    const validateIds = async (isSuitable: (id: string) => Promise<boolean>) => {
        const suitability = await Promise.all(ids.map(isSuitable))
        const newSuitableIds = ids.filter((_, idx) => suitability[idx])
        setSuitableIds(newSuitableIds)
        if (newSuitableIds.length < ids.length) {
            const part1 = `De los ${ids.length} items seleccionados, `
            const part2 = newSuitableIds.length > 0 ? `sólo ${newSuitableIds.length} están aptos para la acción seleccionada.` : 'no hay ninguno apto para la acción seleccionada.'
            setValidation(`${part1} ${part2}`)
        } else {
            setValidation(undefined)
        }
    }

    useEffect(() => {
        const bulkAction = findBulkAction(selectedAction.id)
        if (bulkAction.isSuitable) {
            validateIds(bulkAction.isSuitable!)
        } else {
            setValidation(undefined)
        }
    }, [selectedAction, ids])

    const options = useMemo(() => bulkActions.map(action => option(action.id, action.label)), [bulkActions])

    const findBulkAction = (id: string) => bulkActions.find(action => action.id === id)!

    const onChangeAction = (value?: string) => setSelectedAction(findBulkAction(value!))

    const onSubmit = () => selectedAction.do(suitableIds)

    return (
        <Modal
            modalId={ModalId.BULK_EDIT}
            title="Editar Masivamente"
            submitLabel={selectedAction.label}
            submitIcon="arrow-right"
            disableSubmit={suitableIds.length === 0}
            onSubmit={onSubmit}
        >
            <>
                <p>Selecciona la acción a aplicar sobre los <strong>{ids.length}</strong> items seleccionados:</p>
                <RadioField
                    id="bulk-edit-action"
                    options={options}
                    value={selectedAction.id}
                    onChange={onChangeAction}
                />
                {validation && (
                    <Validatable
                        validations={toList(validation)}
                        type={suitableIds.length > 0 ? "warning" : "error"}
                        expanded
                    />
                )}
            </>
        </Modal>
    )
}
